import request from "@/utils/request";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;

export function getUserInfo() {
  return request({
    url: `${BASE_API}/api/user`,
    method: "get",
  });
}
export function getServerStatus() {
  return request({
    url: `${BASE_API}/api/server_status`,
    method: "get",
  });
}

